"use client";

import { useTranslations } from "next-intl";
import { parseRichMessage } from "./parseRichMessage";
import { logger } from "@lib/logger";
import "./RichText.css";

type RichTextProps = {
  translationKey: string;
};

export default function RichText({ translationKey }: RichTextProps) {
  const t = useTranslations();

  if (!translationKey) {
    return null;
  }

  let message: unknown;
  try {
    message = (t.raw as (key: string) => unknown)(translationKey);
  } catch (err) {
    logger.error("i18n", "RichText translation key failed to resolve", err, { translationKey });
    return null;
  }
  if (typeof message !== "string") {
    return null;
  }
  return <>{parseRichMessage(message, translationKey)}</>;
}
